import { ObservableLevelsEnum } from '../data/enums';

/**
 * Resolves the entityId an observation is submitted with (#10207).
 *
 * Observations recorded against the changeout-to bucket must be submitted with
 * entityId -1 even when the bucket already has a server id: the server
 * validates EntityId > 0 equipment observations against the PRE-move database
 * state (ObservationDtoValidator), so the real id is rejected while the same
 * request is asserting the reassignment. With -1 the server validates against
 * the request's equipmentItems by entityExternalId (SaveInspectionsValidator)
 * and maps the observation onto the NEW equipment row it inserts for the
 * reinstallation (HandleEquipmentObservationMapping).
 *
 * Old-bucket observations keep their real id — the old bucket is still on the
 * asset in the database at validation time, and it ships detached in
 * equipmentItems, so rewriting those would instead fail the payload check.
 */
export function resolveSubmitEntityId({
  entityId,
  dataLevelId,
  entityExternalId,
  changeoutBucketExternalId,
}: {
  entityId: number;
  dataLevelId: number;
  entityExternalId: string;
  changeoutBucketExternalId: string | null;
}): number {
  if (entityId === 0) {
    return -1;
  }

  if (
    changeoutBucketExternalId !== null &&
    entityId > 0 &&
    dataLevelId === ObservableLevelsEnum.equipment &&
    entityExternalId === changeoutBucketExternalId
  ) {
    return -1;
  }

  return entityId;
}
